<template>
    <div class="container-fluid p-0 m-0">
        <div v-if="!hasChildren">
            <div class="container">
                <!-- HEADER -->
                <div class="header row p-0 m-0">
                    <div class="col-12 col-lg-6 p-0 m-0">
                        <img :src="`${publicPath}img/sostenibilidad.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
                    </div>
                    <div class="col-12 col-lg-6 text-start p-5">
                        <h1 class="text-blue mt-3 mb-0">{{ $t('sostenibilidad.title') }}</h1>
                        <p>{{ $t('sostenibilidad.acciones') }}</p>
                    </div>
                </div>
                <!-- end HEADER -->

                <section class="p-0 p-lg-5 pt-5 pb-lg-0 mx-0 mx-lg-5">

                    <div class="row px-0 px-lg-5">
                        <div class="col-12 col-lg-6 px-4 mb-5 text-start">
                            <localized-link to="/sostenibilidad/plan-de-rsc-y-sostenibilidad-21-24">
                                <img :src="`${publicPath}img/Grupo-2477${locale}.jpg`" data-aos="fade-right" data-aos-duration="1000" class="img-responsive border border-light mb-3">
                            </localized-link>
                            <div class="row">
                                <h4><strong>{{ $t('sostenibilidad.plan') }}</strong>
                                    <localized-link class="text-end btnPlus float-end" to="/sostenibilidad/plan-de-rsc-y-sostenibilidad-21-24"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></localized-link>
                                </h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 px-4 mb-5 text-start">
                            <localized-link to="/sostenibilidad/nuestra-contribucion-a-los-ods">
                                <img :src="`${publicPath}img/Grupo-2478.jpg`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive border border-light mb-3">
                            </localized-link>
                            <div class="row">
                                <h4><strong>{{ $t('sostenibilidad.contribucion') }}</strong>
                                    <localized-link class="text-end btnPlus float-end" to="/sostenibilidad/nuestra-contribucion-a-los-ods"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></localized-link>
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-8 px-4 m-auto">
                            <div class="container border border-light p-3 m-0 mb-5">
                                <h2 class="mt-5 mb-3">{{ $t('nav.impacto-entorno') }}</h2>
                                <div class="row">
                                    <localized-link class="text-end btnPlus" to="/sostenibilidad/impacto-en-el-entorno"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></localized-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- NAVEGACIÓ PRE-FOOTER -->
                <hr>
                <div class="row p-0 g-0 mb-3">
                    <div class="col-6 p-0 m-0 pb-3 text-start">
                        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/organizacion-y-buen-gobierno"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.organizacion-y-buen-gobierno") }}</localized-link>
                    </div>
                    <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
                        <localized-link class="footerLink" to="/sostenibilidad/plan-de-rsc-y-sostenibilidad-21-24"> {{ $t("nav.plan-de-rsc-y-sostenibilidad-21-24") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        props: {
            hasChildren: Boolean
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                locale:this.$i18n.locale,
            }
        }
    }
</script>
